import { format, parseISO } from 'date-fns';
import { Icon } from '../Icon/Icon';
import { TimeElement } from '../TimeElement/TimeElement';
import formatCloseRelative from '../Util/formatCloseRelative';
import { type Situation } from './Situation.types';
import { getDateStrings } from './SituationDateHelper';

export interface ISituationListProps {
    items: Situation[];
}

const SituationTimeDetails = ({ situation }: { situation: Situation }) => {
    const startTime = parseISO(situation.startTime);
    const endTime = situation.endTime ? parseISO(situation.endTime) : null;

    const texts = getDateStrings(startTime, endTime);

    // Special handling for same-day situations with time range
    if (endTime && startTime.toDateString() === endTime.toDateString()) {
        const now = new Date();

        return (
            <div>
                Giltig{' '}
                <TimeElement date={startTime}>{`${formatCloseRelative(startTime, 'noTime', now)} kl. ${format(startTime, 'HH.mm')}`}</TimeElement>
                {' - '}
                <TimeElement date={endTime}>{`${format(endTime, 'HH.mm')}`}</TimeElement>
            </div>
        );
    }

    return (
        <>
            <div>
                {`Giltig ${texts.to ? 'från: ' : ''}`}
                <TimeElement date={startTime}>{texts.from}</TimeElement>
            </div>
            {texts.to && (
                <div>
                    {`Beräknas pågå till: `}
                    <TimeElement date={endTime}>{texts.to}</TimeElement>
                </div>
            )}
        </>
    );
};

export const SituationList = ({ items }: ISituationListProps) => {
    return (
        <div className="linkable-item-list block block--light p-0">
            {items.map((situation, index) => (
                <div key={situation.id} className="linkable-item-list__item">
                    {index > 0 && <hr />}
                    <a href={situation.detailsPath}>
                        <div className="d-flex w-100 py-3 px-3">
                            <div className="align-self-center me-3">
                                <Icon symbol={situation.iconId} className="linkable-item-list__item-icon" />
                            </div>

                            <div>
                                <div className="mb-1 fw-bold">{situation.title}</div>
                                {!situation.workState && <SituationTimeDetails situation={situation} />}
                                {!!situation.workState && <div>{situation.workStateText}.</div>}
                                {situation.municipalities && situation.municipalities.length > 0 && (
                                    <div>
                                        {situation.municipalities.length > 1 ? 'Kommuner: ' : 'Kommun: '}
                                        {situation.municipalities.join(', ')}
                                    </div>
                                )}
                                {situation.lines && situation.lines.length > 0 && (
                                    <div>
                                        {situation.lines.length > 1 ? 'Linjer: ' : 'Linje: '}
                                        {situation.lines.join(', ')}
                                    </div>
                                )}
                            </div>
                        </div>
                    </a>
                </div>
            ))}
        </div>
    );
};
